import React from "react";

const DEFAULT_BANNER = '/defaults/default-banner.svg';
const handleImgError = (e) => { e.target.onerror = null; e.target.src = DEFAULT_BANNER; };

function CommissionBanner({ sliderCommssion = [] }) {
  return (
    <div className="et-l et-l--body">
      <div className="et_builder_inner_content et_pb_gutters3">
        <div className="et_pb_section et_pb_section_0_tb_body et_section_regular">
          <div className="et_pb_row et_pb_row_0_tb_body">
            <div className="et_pb_column et_pb_column_4_4 et_pb_column_0_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
              <div className="et_pb_module et_pb_text et_pb_text_0_tb_body et_pb_text_align_center et_pb_bg_layout_light">
                <div className="et_pb_text_inner">
                  <h1>Commission Plan</h1>
                  <p>Discover our competitive commission structure</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {sliderCommssion.length > 0 && (
          <div className="et_pb_section et_pb_section_1_tb_body et_section_regular">
            <div className="et_pb_row et_pb_row_1_tb_body">
              <div className="et_pb_column et_pb_column_4_4 et_pb_column_1_tb_body et_pb_css_mix_blend_mode_passthrough et-last-child">
                {sliderCommssion.map((item, i) => {
                  const imgPath = item.thumbnail || item.thubmnail;
                  return (
                    <div key={i} className="et_pb_module et_pb_image et_pb_image_tb_body" style={{ marginBottom: '30px', textAlign: 'center' }}>
                      {imgPath ? (
                        <span className="et_pb_image_wrap">
                          <img decoding="async" src={`${process.env.REACT_APP_API_URL}/storage/${imgPath}`} alt={item.name || ''} style={{ maxWidth: '100%', borderRadius: '10px' }} onError={handleImgError} />
                        </span>
                      ) : (
                        <span className="et_pb_image_wrap">
                          <img decoding="async" src={DEFAULT_BANNER} alt={item.name || 'Commission'} style={{ maxWidth: '100%', borderRadius: '10px' }} />
                        </span>
                      )}
                      {item.name && <h3 className="yellow-color" style={{ marginTop: '15px' }}>{item.name}</h3>}
                      {item.link && <div dangerouslySetInnerHTML={{ __html: item.link }} />}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default CommissionBanner;
